import awsJson from '../configs/aws.json';
import {IS_DOCKER} from '../shared/utils/enum';

export const aws_info = awsJson;

export const getBannerImageUrl = (target, img) => {
    const info = aws_info[target];
    if (!info || !img) return undefined;

    if (IS_DOCKER) {
        return `${process.env.REACT_APP_IMAGE_URL}/repo/${info.imgPath}${img}`;
    }
    return `https://${info.s3bucket}.s3.${aws_info.s3region}.amazonaws.com/${info.imgPath}${img}`;
}
